import React from 'react';
import ReactDOM from 'react-dom/client';
import './utils/fetchInterceptor.js'; // ⚠️ Debe estar ANTES de App.jsx
import App from './App.jsx';
import './index.css';
import { AuthProvider } from './context/authContext.jsx';
import { registerMapTileCache } from './utils/mapTileCache.js';

registerMapTileCache();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
